import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Root } from './Root.tsx';
// Fonts served from our own origin: no request to Google Fonts (no visitor IP sent to a third party).
import '@fontsource/geist/300.css';
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import '@fontsource/geist/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import '@fontsource/source-serif-4/400-italic.css';
import './styles.css';
import './app.css';
import './skin.css';
// Sign-in, onboarding and the first test in the landing's editorial look.
import './auth-editorial.css';
import './landing.css';
// The home page's own look, scoped under .dvl; after the app's styles so they never reach into it.
import './pages/public/landing/landing.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </StrictMode>,
);
